import React from 'react';
import { Helmet } from 'react-helmet-async';
import MainNavbar from '../components/MainNavbar';
import MainFooter from '../components/MainFooter';
import useSiteBootstrap from '../hooks/useSiteBootstrap';
import LandingHero from '../components/landing/LandingHero';
import LandingOverviewGrid from '../components/landing/LandingOverviewGrid';
import LandingComparison from '../components/landing/LandingComparison';
import LandingPricing from '../components/landing/LandingPricing';
import LandingFaq from '../components/landing/LandingFaq';
import LandingFinalCta from '../components/landing/LandingFinalCta';
import LandingSkeleton from '../components/landing/LandingSkeleton';
import { parseLandingContent } from '../components/landing/landingContent';
import '../styles/landing.css';

export default function LandingPage() {
  const site = useSiteBootstrap();

  const isLoading = !site || !site.settings;

  if (isLoading) {
    return (
      <div className="landing-scope">
        <MainNavbar />
        <LandingSkeleton />
        <MainFooter />
      </div>
    );
  }

  const settings = site?.settings || {};
  const content = parseLandingContent(settings?.landing_content);
  const plans = Array.isArray(site?.plans) ? site.plans : [];

  const title = settings?.seo_title || settings?.site_name || '';
  const description = settings?.seo_description || '';
  const keywords = settings?.seo_keywords || '';
  const favicon = settings?.favicon_url || '/favicon.ico';

  return (
    <div className="landing-scope">
      <Helmet>
        <title>{title}</title>
        {description ? <meta name="description" content={description} /> : null}
        {keywords ? <meta name="keywords" content={keywords} /> : null}
        {title ? <meta property="og:title" content={title} /> : null}
        {description ? <meta property="og:description" content={description} /> : null}
        <link rel="icon" href={favicon} />
      </Helmet>

      <MainNavbar />

      <LandingHero settings={settings} content={content} />

      <LandingOverviewGrid content={content} settings={settings} />

      <LandingComparison content={content} />

      <LandingPricing plans={plans} content={content} />

      <LandingFaq content={content} />

      <LandingFinalCta content={content} settings={settings} />

      <MainFooter />
    </div>
  );
}